<template>
  <v-dialog persistent v-model="show">
    <section id="wholeSaler" class="pa-3">
      <v-row no-gutters>
        <v-col cols="12" class="mb-3 mt-3">
          <p class="font--m-4 mb-0">거래처 찾기</p>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="keyword"
            solo
            single-line
            hide-details
            outlined
            flat
            placeholder="검색어를 입력해주세요"
            class="mb-5"
            @keyup.enter="getSaler()"
          >
            <template v-slot:append>
              <v-icon class="cursor--pointer" @click="getSaler()"> mdi-magnify </v-icon>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <ul id="saler-list">
            <template v-if="selectedSaler.uuid">
              <li class="selected">
                <router-link
                  id="btn__JHFAZFELqEKz4QBpkP7YVw=="
                  :to="{ path: `/payments/form`, query: { wholesalerId: selectedSaler.uuid } }"
                >
                  <p class="font-weight-bold mb-0 text-ellipsis">
                    <span class="font--m-5 mr-3">{{ selectedSaler.name }}</span>
                    <span class="font--m-7 color--gray-80 mt-1">{{ selectedSaler.location }} </span>
                    <v-spacer></v-spacer>
                    <span class="font--m-5 mr-3 mr-1">(선택됨)</span>
                    <v-icon class="cursor--pointer" @click="selectSaler(null)"> mdi-close </v-icon>
                  </p>
                </router-link>
              </li>
            </template>
            <template v-if="noData">
              <li class="is-empty">
                <p class="font--m-4 mb-0">검색된 상점이 없습니다</p>
              </li>
            </template>
            <template v-else>
              <li v-for="saler in showList" :key="saler.uuid" @click="selectSaler(saler)">
                <p class="mb-0 text-ellipsis font--m-5">{{ saler.name }}</p>
                <p class="mb-0 text-ellipsis font--m-7 color--gray-80">{{ saler.location }}</p>
              </li>
            </template>
          </ul>
        </v-col>

        <v-col cols="12" class="mt-5 mb-5text-center">
          <BasicButton
            color="black"
            :to="{ path: '/wholesaler/form' }"
            id="btn__HxQIlb16q02t8ZQ1EBixyQ=="
            >원하는 거래처가 없어요</BasicButton
          >
        </v-col>
      </v-row>
    </section>
  </v-dialog>
</template>

<script>
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  data() {
    return {
      isLoading: false,
      keyword: null,
      searchHistory: {},
      salerList: [],
      selectedSaler: {
        uuid: null,
        name: null,
        location: null,
      },
      showDialog: false,
    }
  },
  components: {
    // RegistrationDisplay,
  },
  props: {
    value: Boolean,
  },
  computed: {
    noData() {
      return this.salerList.length > 0 === false
    },
    showList() {
      return this.salerList.filter((saler) => saler.uuid !== this.selectedSaler.uuid)
    },
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    insertHistory(keyword, value) {
      let temp = value
      if (Array.isArray(value) === false) {
        temp = []
      }
      this.searchHistory[keyword] = [...temp]
    },
    async selectSaler(saler) {
      if (saler === null) {
        this.selectedSaler = {
          uuid: null,
          name: null,
          location: null,
        }
        this.keyword = null
        this.getSaler()
        return
      }
      this.selectedSaler = saler
      await this.getSaler(true)
      this.keyword = saler.name
    },
    async getSaler(byUuid = false) {
      const keyword = byUuid ? this.selectedSaler.uuid : this.keyword
      if (!keyword) {
        this.salerList = []
        return
      }

      if (byUuid) {
        this.insertHistory(keyword, [this.selectedSaler])
      }

      if (this.searchHistory?.[keyword]) {
        this.salerList = this.searchHistory?.[keyword]
        return
      }

      try {
        const { data } = await defaultApi.getWholesalers({ search: keyword })
        this.insertHistory(keyword, data?.results)
      } catch (e) {
        this.$swal.basic.alert(e?.message)
        throw e
      }

      this.salerList = this.searchHistory?.[keyword] || []
    },
  },
}
</script>

<style lang="scss" scoped>
#wholeSaler {
  background-color: #ffffff;

  #saler-list {
    width: 100%;
    min-height: 250px;
    max-height: 250px;
    overflow-y: auto;
    border: 1px solid $black;
    list-style: none;
    padding: 0;
  }
  li {
    background-color: $white;
    cursor: pointer;
    padding: 15px 15px;

    &:hover {
      background-color: $gray-80;
    }

    &.is-empty {
      height: 245px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.selected {
      background-color: $main-color-default !important;

      p {
        display: flex;
        justify-content: space-between;
      }

      span {
        color: white;
      }
    }
  }
}
</style>
